// Sync GTM consent with Shopify Customer Privacy
(function syncGtmWithShopifyConsent() {
  function mapConsentToGtag(consent) {
    try {
      var update = {
        ad_storage: consent && consent.marketing ? 'granted' : 'denied',
        analytics_storage: consent && consent.analytics ? 'granted' : 'denied',
        functionality_storage: consent && consent.preferences ? 'granted' : 'denied',
        personalization_storage: consent && consent.preferences ? 'granted' : 'denied',
        security_storage: 'granted',
        ad_user_data: consent && consent.marketing ? 'granted' : 'denied',
        ad_personalization: consent && consent.marketing ? 'granted' : 'denied'
      };
      if (typeof window.gtag === 'function') {
        window.gtag('consent', 'update', update);
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: 'gtm.consentUpdate', consentUpdate: update });
      }
    } catch (e) {
      // no-op
    }
  }
  function init() {
    if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.getTrackingConsent === 'function') {
      var result = Shopify.customerPrivacy.getTrackingConsent();
      if (result && typeof result.then === 'function') {
        result.then(function (c) { mapConsentToGtag(c); });
      } else {
        mapConsentToGtag(result);
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:customer_privacy:consent_changed', function (e) {
    mapConsentToGtag(e && e.detail);
  });
})();



